/* eslint-disable react/forbid-prop-types */
import Text from '@deprecated-ui/common/Text';
import Image from 'global/Image';
import React from 'react';
import { OptionItemContainer } from './styled';

interface OptionItemProps {
  children: React.ReactNode;
  isActive?: number|boolean;
  iconName: string;
  [key: string]: any;
}

function OptionItem({ children, isActive = false, iconName, ...otherProps }: OptionItemProps) {
  const iconFile = isActive
    ? `icon/post-${iconName}-active.svg`
    : `icon/post-${iconName}.svg`;
  return (
    <OptionItemContainer {...otherProps}>
      <Image width="16" height="15" src={iconFile} />
      {/* @ts-expect-error */}
      <Text ml="12px">{children}</Text>
    </OptionItemContainer>
  );
}

export default OptionItem;
